import type { ReactNode } from 'react';
import { Lock } from '@phosphor-icons/react';
import { useNavigate } from 'react-router-dom';
import { Sidebar } from '@/components/layout/sidebar';
import { Button } from '@/components/ui/button';
import { usePermissions } from '@/hooks/usePermissions';

interface PermissionGateProps {
  /** Permissions ; il suffit d'en avoir une (les admins passent toujours). */
  anyOf: string[];
  children: ReactNode;
}

/**
 * Garde de page basée sur les permissions, à utiliser autour d'un élément de route.
 * Affiche un écran « Accès refusé » (avec la sidebar) si l'utilisateur n'a aucune
 * des permissions requises. Sert de défense en profondeur : le backend enforce déjà
 * les routes API, ceci évite une page cassée en cas d'accès par URL directe.
 */
export function PermissionGate({ anyOf, children }: PermissionGateProps) {
  const { hasAnyPermission, isLoading } = usePermissions();
  const navigate = useNavigate();

  if (isLoading) return null;
  if (hasAnyPermission(anyOf)) return <>{children}</>;

  return (
    <div className="flex h-screen">
      <Sidebar />
      <div className="flex-1 overflow-auto p-3">
        <div className="bg-white rounded-goutte shadow-sm border">
          <div className="p-12 text-center">
            <Lock className="h-16 w-16 text-ink-muted mx-auto mb-4" />
            <h2 className="text-2xl font-bold text-ink mb-2">Accès refusé</h2>
            <p className="text-ink-muted mb-6">
              Vous n'avez pas les permissions nécessaires pour accéder à cette page.
              Contactez un administrateur du cabinet.
            </p>
            <Button className="cursor-pointer" onClick={() => navigate('/dashboard')}>
              Retour au tableau de bord
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
}
